"use strict";
/// <reference path="irep.js"/>

IREP.pointmeter2 = (function () {

    jQuery.fn.reverse = [].reverse;

    var init = function (options) {

        $("#divDetail").click(function () {
            if ($("#divReq").css("display") === "none") {

                $("#divReq").slideDown();

                $(".item").each(function (index) {
                    $(this).delay(100 * index).animate({ opacity: 1 }, 500); 
                });

                $("#aDetailText").html(options.mtrCollapseDetails);
            }
            else {

                $(".item").reverse().each(function (index) {
                    $(this).delay(100 * index).animate({ opacity: 0 }, 300);
                    if (index == 0) {

                        $("#divReq").delay(100 * $(".item").length+ 200).slideUp(200);
                    }
                }); 
                $("#aDetailText").html(options.mtrViewDetails);
            }
            return false;
        });
    };


    return {
        init: init
    };
})();
